var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCashAdvanceReadyTransfer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 84,
    viewBox: "0 0 82 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 84V44H40.0965V84H80Z",
    fill: "#A4E5CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9492 63.7905V23.7905L20.0457 23.7905V63.7905H59.9492Z",
    fill: "#0577FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 44V4L0.0965233 4V44H40Z",
    fill: "#144E50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0483 64.0367L20.0069 64.0422H20.0483L0 84.0007V66.9724V64.0422V44.0781L20.0483 64.0367Z",
    fill: "#4F9C79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1018 64.0367L40.0577 64.0422H40.1018L20.0508 84.0007L20.0535 66.9724V64.0422V44.0781L40.1018 64.0367Z",
    fill: "#4F9C79"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0508 63.7934H39.8564L20.0508 44.0781V63.7934Z",
    fill: "#1C1C1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3125 26.7098V26.9724C13.3125 29.8943 15.6841 32.2716 18.599 32.2716H19.2773V35.4368H20.7113V32.2716H21.3401C22.7603 32.2716 24.0757 31.7962 25.0464 30.9337C26.064 30.0298 26.6265 28.7526 26.6265 27.3428C26.6265 24.5232 24.4038 22.4776 21.3401 22.4776H20.7113V15.5806H21.3428C23.4662 15.5806 25.1953 17.3138 25.1953 19.4423V19.705H26.6293V19.4423C26.6293 16.5204 24.2577 14.1431 21.3428 14.1431H20.7113V11.1438H19.2773V14.1431H18.599C17.1788 14.1431 15.8633 14.6186 14.8926 15.481C13.8751 16.385 13.3125 17.6621 13.3125 19.0719C13.3125 21.8916 15.5352 23.9372 18.599 23.9372H19.2773V30.8342H18.599C16.4755 30.8342 14.7465 29.101 14.7465 26.9724V26.7098H13.3125ZM21.3401 23.915C23.6096 23.915 25.1925 25.3249 25.1925 27.3428C25.1925 29.3608 23.571 30.8342 21.3401 30.8342H20.7113V23.915H21.3401ZM18.6017 22.4997C16.3321 22.4997 14.7492 21.0899 14.7492 19.0719C14.7492 17.054 16.3708 15.5806 18.6017 15.5806H19.2801V22.4997H18.6017Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0098 0.6521H51.3594V6.97442H53.0098V0.6521Z",
    fill: "#1C1C1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5546 4.99241L66.1697 4.20093L62.9891 9.64478L64.3775 10.4358L67.5546 4.99241Z",
    fill: "#1C1C1C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9727 15.9673L77.1634 14.5837L71.5828 17.7496L72.3925 19.1296L77.9727 15.9673Z",
    fill: "#1C1C1C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3976 29.081H75.0562V30.6005H81.3976V29.081Z",
    fill: "#1C1C1C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCashAdvanceReadyTransfer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Cash-Advance-Ready-Transfer.cf3a848b22e70c09ec260180f6583135.svg";